import recruitmentAPIIndex, { dashboardApiIndex, encryptStorage } from '../constant';
import { candidateclient, client, performanceClient } from './RecruiterClient';
import { dashboardClient } from './client';
//PS_BC_12
export const getFresherCandidate = async (data) => {
    //PC_RC_21
    //PC_RC_22
    try {
        //PC_RC_23
        let body = {
            modulename: recruitmentAPIIndex.modulename.CandidateGrid,
            // methodname: recruitmentAPIIndex.methodname.getFresherCandidate,
            methodname: recruitmentAPIIndex.methodname.getFresherInterview,

            payload: data,
        };
        const response = await client(body); //PC_RC_24
        return response;
    } catch (error) {
        throw error;
    }
};

export const getSalaryDetails = async (data) => {
    try {
        let body = {
            modulename: recruitmentAPIIndex.modulename.OfferDetails,
            methodname: recruitmentAPIIndex.methodname.getSalaryDetails,
            payload: data,
        };
        const response = await client(body);
        return response;
    } catch (error) {
        throw error;
    }
};

export const getReportingDetails = async (data) => {
    try {
        let body = {
            modulename: recruitmentAPIIndex.modulename.OfferDetails,
            methodname: recruitmentAPIIndex.methodname.getReportingDetails,
            payload: data,
        };
        const response = await client(body);
        return response;
    } catch (error) {
        throw error;
    }
};

export const postReportingDetails = async (data) => {
    try {
        let body = {
            modulename: recruitmentAPIIndex.modulename.OfferDetails,
            methodname: recruitmentAPIIndex.methodname.postReportingDetails,
            payload: data,
        };
        const response = await client(body);
        return response;
    } catch (error) {
        throw error;
    }
};

export const updateReportingDetails = async (data) => {
    try {
        let body = {
            modulename: recruitmentAPIIndex.modulename.OfferDetails,
            methodname: recruitmentAPIIndex.methodname.updateReportingDetails,
            payload: data,
        };
        const response = await client(body);
        return response;
    } catch (error) {
        throw error;
    }
};

//PC_RC_39
export const getExperienceCandidate = async (data) => {
    try {
        // PC_RC_40
        let body = {
            modulename: recruitmentAPIIndex.modulename.CandidateGrid,
            // methodname: recruitmentAPIIndex.methodname.getExpCandidate,
            methodname: recruitmentAPIIndex.methodname.getJobCandidate,

            payload: data,
        };
        //PC_RC_41
        const response = await client(body);
        return response;
    } catch (error) {
        throw error;
    }
};

// Get the interview round dropdown
/**
 *  PS_04 - PS_17 -- getInterview function gets triggered Where it shows the dropdown function
 */
export const getInterviewRound = async (payload) => {
    try {
        let body = {
            modulename: recruitmentAPIIndex.modulename.InterviewRound,
            methodname: recruitmentAPIIndex.methodname.getInterviewRound,
            payload: payload,
        };
        const response = await client(body);
        return response;
    } catch (error) {}
};

// Insert the schedule Interview Data for fresher and experience

export const postInterview = async (data) => {
    try {
        let body = {
            modulename: recruitmentAPIIndex.modulename.InterviewRound,
            methodname: recruitmentAPIIndex.methodname.postInterview,
            payload: data,
        };
        const response = await client(body);
        return response;
    } catch (error) {}
};

export const postExpInterview = async (data) => {
    try {
        let body = {
            modulename: recruitmentAPIIndex.modulename.InterviewRound,
            methodname: recruitmentAPIIndex.methodname.postExpInterview,
            payload: data,
        };
        const response = await client(body);
        return response;
    } catch (error) {}
};
// Insert the schedule Interview Data

////////  JOB LANDING PAGE ////////////////

export const getJobsData = async (job = {}) => {
    try {
        let body = {
            modulename: recruitmentAPIIndex.modulename.Jobs,
            methodname: recruitmentAPIIndex.methodname.getJobs,
            payload: job,
        };
        const response = await client(body);
        return response;
    } catch (error) {}
};

////////  JOB POSTING FORM ////////////////
/**
 * 
 * PS_08 - PS_21 -- Declaring the async function as getDropDown() get the dropdown details from the backend
 */

export const getDropdown = async () => {
    try {
        let body = {
            modulename: recruitmentAPIIndex.modulename.Jobs,
            methodname: recruitmentAPIIndex.methodname.getFormDropDownValues,
            payload: '',
        };
        const response = await client(body);
        return response;
    } catch (error) {}
};

/**
 * PS_32 - PS_45 -- Declaring the async function as postJobData() posting the data's which is taken from the backend
 */
export const postJobData = async (data) => {
    try {
        let body = {
            modulename: recruitmentAPIIndex.modulename.Jobs,
            methodname: recruitmentAPIIndex.methodname.postJobs,
            payload: data,
        };
        const response = await client(body);
        return response;
    } catch (error) {}
};
export const getLogin1 = async (data) => {
    return await client(data);
};

/////////JOBS INFORMATION OR BOARDS //////////
/**
 * PS_06 - PS_19 -- Declaring the async function as getJobsInformation() get the dropdown details from the backend 
 */
export const getJobsInformation = async (data) => {
    try {
        let body = {
            modulename: recruitmentAPIIndex.modulename.Jobs,
            methodname: recruitmentAPIIndex.methodname.getJobInfo,
            payload: data,
        };
        const response = await client(body)
        return response;
    } catch (error) {}
};
/**
 * PS_32 - PS_46 -- Async function have declared for updateJobs()  updating the dropdown details from the backend and it will be shown in the frontend.
 */
export const updateJobs = async (data) => {
    try {
        let body = {
            modulename: recruitmentAPIIndex.modulename.Jobs,
            methodname: recruitmentAPIIndex.methodname.updateJob,
            payload: data,
        };
        const response = await client(body);
        return response;
    } catch (error) {}
};

///////////////////////HOLD CANDIDATES/////////

export const insertHoldCandidate = async (data) => {
    //PC_HC_15
    try {
        //PC_HC_16
        let body = {
            modulename: recruitmentAPIIndex.modulename.CandidateGrid,
            methodname: recruitmentAPIIndex.methodname.postHoldCandidate,
            payload: data,
        };
        const response = await client(body); //PC_HC_17
        return response; //PC_HC_23
    } catch (error) {}
};

/////////////////////FEEDBACK TABLE///////////////

export const getFeedBack = async (data) => {
    try {
        let body = {
            modulename: recruitmentAPIIndex.modulename.Feedback,
            methodname: recruitmentAPIIndex.methodname.getFeedback,
            payload: data,
        };
        const response = await client(body);
        return response;
    } catch (error) {}
};

////////////////////////GET CANDIDATE PROFILE/////////////

export const getProfile = async (data) => {
    try {
        let body = {
            modulename: recruitmentAPIIndex.modulename.CandidateGrid,
            methodname: recruitmentAPIIndex.methodname.getCandidateProfile,
            payload: data,
        };
        const response = await client(body);
        return response;
    } catch (error) {}
};

//PC_O_05,PC_O_06
//This method is used to get the onboarding Candidates
/**
 * PS_04 - PS_06 -- API call to fetch the onboarding candidates
 */
export const getOnboardingCandidate = async () => {
    let body = {
        modulename: recruitmentAPIIndex.modulename.Onboarding,
        methodname: recruitmentAPIIndex.methodname.getonboardingGrid,
        payload: '',
    };
    const response = await client(body);

    return response;
};
//PC_OS_13,PC_OS_14
//Get the user entered search data from db
export const getSearchData = async (data) => {
    let body = {
        modulename: recruitmentAPIIndex.modulename.Onboarding,
        methodname: recruitmentAPIIndex.methodname.getSearchData,
        payload: data,
    };
    const response = await client(body);

    return response;
};
export const getAllHiringMembers = async (data) => {
    let body = {
        modulename: recruitmentAPIIndex.modulename.Jobs,
        methodname: recruitmentAPIIndex.methodname.getHiringMembers,
        payload: data,
    };
    const response = await client(body);

    return response;
};

//PC_OF_03,PC_OF_04
//Get the user entered filter data
export const getFilterData = async (data) => {
    let body = {
        modulename: recruitmentAPIIndex.modulename.Onboarding,
        methodname: recruitmentAPIIndex.methodname.getFilterData,
        payload: data,
    };
    const response = await client(body);

    return response;
};
//PC_O_S_03,PC_O_S_04
//Get the data when the user clicks the sort icon in the grid
export const getSortData = async (data) => {
    let body = {
        modulename: recruitmentAPIIndex.modulename.Onboarding,
        methodname: recruitmentAPIIndex.methodname.getSortData,
        payload: data,
    };
    const response = await client(body);

    return response;
};
//PC_M_02,PC_M_03
/**
 * PS_24 - PS_29 -- This method is called when the user clicks the mark as not join button
 */
export const updateMarkAsNotJoin = async (data) => {
    let body = {
        modulename: recruitmentAPIIndex.modulename.Onboarding,
        methodname: recruitmentAPIIndex.methodname.postmarkNotJoining,
        payload: data,
    };
    const response = await client(body);

    return response;
};
//PC_H_03,PC_H_04
//This method is called when the user clicks the Hold button
export const updateHold = async (data) => {
    let body = {
        modulename: recruitmentAPIIndex.modulename.CandidateGrid,
        methodname: recruitmentAPIIndex.methodname.updateCandidate,
        payload: data,
    };
    const response = await client(body);

    return response;
};
export const addToteam = async (data) => {
    let body = {
        modulename: recruitmentAPIIndex.modulename.Onboarding,
        methodname: recruitmentAPIIndex.methodname.getSortData,
        payload: data,
    };
    const response = await client(body);

    return response;
};

export const postHiring = async (data) => {
    let body = {
        modulename: recruitmentAPIIndex.modulename.Jobs,
        methodname: recruitmentAPIIndex.methodname.addHiringMember,
        payload: data,
    };
    const response = await client(body);

    return response;
};
export const getHiringTeam = async (data) => {
    let body = {
        modulename: recruitmentAPIIndex.modulename.Jobs,
        methodname: recruitmentAPIIndex.methodname.getHiringTeam,
        payload: data,
    };
    const response = await client(body);

    return response;
};
/**
 * PS_MH_49 - PS_MH_51
 * The function to insert the interview rounds and the interview screening rounds
 */
export const addInterviewRound = async (data) => {
    let body = {
        modulename: recruitmentAPIIndex.modulename.Jobs,
        methodname: recruitmentAPIIndex.methodname.addInterviewRound,
        payload: data,
    };
    const response = await client(body);
    return response;
};
/**
 * PS_MH_22 - PS_MH_23
 * The deleteScreening to removw the screning rounds from the form.
 */
export const deleteScreening = async (data) => {
    let body = {
        modulename: recruitmentAPIIndex.modulename.Jobs,
        methodname: recruitmentAPIIndex.methodname.deleteScreening,
        payload: data,
    };
    const response = await client(body);
    return response;
};
export const getStageRound = async (data) => {
    let body = {
        modulename: recruitmentAPIIndex.modulename.Jobs,
        methodname: recruitmentAPIIndex.methodname.getHiringProcess,
        payload: data,
    };
    const response = await client(body);

    return response;
};

///////// GET OFFER DETAILS ///////

export const getOfferDetails = async (data) => {
    try {
        let body = {
            modulename: recruitmentAPIIndex.modulename.OfferDetails,
            methodname: recruitmentAPIIndex.methodname.getCandidateOfferDetails,
            payload: data,
        };
        const response = await client(body);
        return response;
    } catch (error) {}
};

export const getScheduledInterview = async (data) => {
    try {
        let body = {
            modulename: recruitmentAPIIndex.modulename.InterviewRound,
            methodname: recruitmentAPIIndex.methodname.getScheduledInterview,
            payload: data,
        };
        const response = await client(body);
        return response;
    } catch (error) {}
};

export const getfresherTimeline = async (data) => {
    try {
        let body = {
            modulename: recruitmentAPIIndex.modulename.Timeline,
            methodname: recruitmentAPIIndex.methodname.getTimeline,
            payload: data,
        };
        const response = await client(body);
        return response;
    } catch (error) {}
};

export const getExperienceTimeline = async (data) => {
    try {
        let body = {
            modulename: recruitmentAPIIndex.modulename.Timeline,
            methodname: recruitmentAPIIndex.methodname.getExpTimeline,
            payload: data,
        };
        const response = await client(body);
        return response;
    } catch (error) {}
};

///////////// Get all candidate data
export const getAllCandidate = async (data) => {
    try {
        let body = {
            modulename: recruitmentAPIIndex.modulename.CandidateGrid,
            methodname: recruitmentAPIIndex.methodname.getAllCandidates,
            payload: data,
        };

        const response = await client(body);
        return response;
    } catch (error) {}
};

export const getAllBasicDetails = async (data) => {
    try {
        let body = {
            modulename: recruitmentAPIIndex.modulename.Onboarding,
            methodname: recruitmentAPIIndex.methodname.getEmployeeDetailsGrid,
            payload: data,
        };
        const response = await client(body);
        return response;
    } catch (error) {}
};

/////////////////// TASKS ///////////

export const getCandidateTask = async (data) => {
    try {
        let body = {
            modulename: recruitmentAPIIndex.modulename.Task,
            methodname: recruitmentAPIIndex.methodname.getTasks,
            payload: data,
        };
        const response = await client(body);
        return response;
    } catch (error) {}
};

export const postFresherCandidateTask = async (data) => {
    try {
        let body = {
            modulename: recruitmentAPIIndex.modulename.Task,
            methodname: recruitmentAPIIndex.methodname.postFresherTasks,
            payload: data,
        };

        const response = await client(body);
        return response;
    } catch (error) {}
};

export const postExpCandidateTask = async (data) => {
    try {
        let body = {
            modulename: recruitmentAPIIndex.modulename.Task,
            methodname: recruitmentAPIIndex.methodname.postExpTasks,
            payload: data,
        };
        const response = await client(body);
        return response;
    } catch (error) {}
};

export const editFresherCandidateTask = async (data) => {
    try {
        let body = {
            modulename: recruitmentAPIIndex.modulename.Task,
            methodname: recruitmentAPIIndex.methodname.updateFresherTasks,
            payload: data,
        };
        const response = await client(body);
        return response;
    } catch (error) {}
};

export const editExpCandidateTask = async (data) => {
    try {
        let body = {
            modulename: recruitmentAPIIndex.modulename.Task,
            methodname: recruitmentAPIIndex.methodname.updateExpTasks,
            payload: data,
        };
        const response = await client(body);

        return response;
    } catch (error) {}
};

export const getCandidateJobDetails = async (data) => {
    try {
        let body = {
            modulename: recruitmentAPIIndex.modulename.CandidateGrid,
            methodname: recruitmentAPIIndex.methodname.getCandidateJobDetails,
            payload: data,
        };
        const response = await client(body);
        return response;
    } catch (error) {}
};

export const getPanelMemberJobs = async (data) => {
    try {
        let body = {
            modulename: recruitmentAPIIndex.modulename.Jobs,
            methodname: recruitmentAPIIndex.methodname.getPanelMemberJob,
            payload: data,
        };
        const response = await client(body);
        return response;
    } catch (error) {}
};
export const deleteInterview = async (data) => {
    try {
        let body = {
            modulename: recruitmentAPIIndex.modulename.Jobs,
            methodname: recruitmentAPIIndex.methodname.deleteInterview,
            payload: data,
        };
        const response = await client(body);
        return response;
    } catch (error) {}
};

export const insertInterviewRound = async (data) => {
    try {
        let body = {
            modulename: recruitmentAPIIndex.modulename.Jobs,
            methodname: recruitmentAPIIndex.methodname.insertRoundAssessment,
            payload: data,
        };
        const response = await client(body);
        return response;
    } catch (error) {}
};

export const updateOnboardingDate = async (data) => {
    let body = {
        modulename: recruitmentAPIIndex.modulename.Onboarding,
        methodname: recruitmentAPIIndex.methodname.postonboardingDate,
        payload: data,
    };
    const response = await client(body);

    return response;
};
export const updateJoiningDate = async (data) => {
    let body = {
        modulename: recruitmentAPIIndex.modulename.Onboarding,
        methodname: recruitmentAPIIndex.methodname.postjoiningDate,
        payload: data,
    };
    const response = await client(body);

    return response;
};

export const updateHoldOnboarding = async (data) => {
    let body = {
        modulename: recruitmentAPIIndex.modulename.Onboarding,
        methodname: recruitmentAPIIndex.methodname.postholdStatusData,
        payload: data,
    };
    const response = await client(body);

    return response;
};

//PC_HC_42
export const updateFresherStatus = async (data) => {
    try {
        //PC_HC_43
        let body = {
            modulename: recruitmentAPIIndex.modulename.CandidateGrid,
            methodname: recruitmentAPIIndex.methodname.updateFresherStatus,
            payload: data,
        };
        const response = await client(body); //PC_HC_44
        return response; //PC_HC_50
    } catch (error) {}
};

//PC_HC_54
export const updateExpStatus = async (data) => {
    try {
        //PC_HC_55
        let body = {
            modulename: recruitmentAPIIndex.modulename.CandidateGrid,
            methodname: recruitmentAPIIndex.methodname.updateExpStatus,
            payload: data,
        };
        const response = await client(body); //PC_HC_56
        return response; // PC_HC_62
    } catch (error) {}
};

export const postFresherInterchange = async (data) => {
    try {
        let body = {
            modulename: recruitmentAPIIndex.modulename.CandidateGrid,
            methodname: recruitmentAPIIndex.methodname.postFresherInterchange,
            payload: data,
        };
        const response = await client(body);
        return response;
    } catch (error) {}
};

export const postExpInterchange = async (data) => {
    try {
        let body = {
            modulename: recruitmentAPIIndex.modulename.CandidateGrid,
            methodname: recruitmentAPIIndex.methodname.postExpInterchange,
            payload: data,
        };
        const response = await client(body);

        return response;
    } catch (error) {}
};

export const getCandidateSearchData = async (data) => {
    try {
        let body = {
            modulename: recruitmentAPIIndex.modulename.CandidateGrid,
            methodname: recruitmentAPIIndex.methodname.getCandidateSearchData,
            payload: data,
        };
        const response = await client(body);
        return response;
    } catch (error) {}
};

export const getCandidateFilterData = async (data) => {
    try {
        let body = {
            modulename: recruitmentAPIIndex.modulename.CandidateGrid,
            methodname: recruitmentAPIIndex.methodname.getCandidateFilterData,
            payload: data,
        };
        const response = await client(body);
        return response;
    } catch (error) {}
};

export const getFresherDocuments = async (data) => {
    try {
        let body = {
            modulename: recruitmentAPIIndex.modulename.Documents,
            methodname: recruitmentAPIIndex.methodname.getFresherDocuments,
            payload: data,
        };
        const response = await client(body);
        return response;
    } catch (error) {}
};

export const getExpDocuments = async (data) => {
    try {
        let body = {
            modulename: recruitmentAPIIndex.modulename.Documents,
            methodname: recruitmentAPIIndex.methodname.getExpDocuments,
            payload: data,
        };
        const response = await client(body);
        return response;
    } catch (error) {}
};

export const postJobActions = async (data) => {
    try {
        let body = {
            modulename: recruitmentAPIIndex.modulename.Jobs,
            methodname: recruitmentAPIIndex.methodname.postJobsActions,
            payload: data,
        };
        const response = await client(body);

        return response;
    } catch (error) {}
};

export const postFresherDocuments = async (data) => {
    try {
        let body = {
            modulename: recruitmentAPIIndex.modulename.Documents,
            methodname: recruitmentAPIIndex.methodname.postFresherDocumentDetails,
            payload: data,
        };
        const response = await client(body);
        return response;
    } catch (error) {}
};

export const postExpDocuments = async (data) => {
    try {
        let body = {
            modulename: recruitmentAPIIndex.modulename.Documents,
            methodname: recruitmentAPIIndex.methodname.postExpDocumentDetails,
            payload: data,
        };
        const response = await client(body);
        return response;
    } catch (error) {}
};
//to get summary tab preliminary details in array ques and ans

export const getPreliminaryDetails = async (data) => {
    try {
        let body = {
            modulename: recruitmentAPIIndex.modulename.CandidateGrid,
            methodname: recruitmentAPIIndex.methodname.getPreliminary,
            payload: data,
        };

        const response = await client(body);

        return response;
    } catch (error) {}
};

//to get Summary tab details in array
//PS_SB_06
export const getSummaryDetails = async (data) => {
    try {
        let body = {
            modulename: recruitmentAPIIndex.modulename.CandidateGrid,
            methodname: recruitmentAPIIndex.methodname.getSummary,
            payload: data,
        };
        const response = await client(body);
        return response;
    } catch (error) {}
};

export const deleteScheduledInterview = async (data) => {
    try {
        let body = {
            modulename: recruitmentAPIIndex.modulename.InterviewRound,
            methodname: recruitmentAPIIndex.methodname.deleteScheduledInterview,
            payload: data,
        };
        const response = await client(body);
        return response;
    } catch (error) {}
};
//PC_FB_20 -> Api function call is defined
//PS_CB_20
export const sendFeedback = async (data) => {
    try {
        let body = {
            modulename: recruitmentAPIIndex.modulename.Feedback,
            methodname: recruitmentAPIIndex.methodname.sendFeedback,
            payload: data,
        };
        const response = await client(body);
        return response;
        //PC_FB_22 -> response is returned
    } catch (error) {}
};

export const getEditScheduledInterview = async (data) => {
    try {
        let body = {
            modulename: recruitmentAPIIndex.modulename.InterviewRound,
            methodname: recruitmentAPIIndex.methodname.getEditScheduledInterview,
            payload: data,
        };
        const response = await client(body);
        return response;
    } catch (error) {}
};

export const updateInterview = async (data) => {
    try {
        let body = {
            modulename: recruitmentAPIIndex.modulename.InterviewRound,
            methodname: recruitmentAPIIndex.methodname.updateInterview,
            payload: data,
        };
        const response = await client(body);
        return response;
    } catch (error) {}
};

export const updateExpInterview = async (data) => {
    try {
        let body = {
            modulename: recruitmentAPIIndex.modulename.InterviewRound,
            methodname: recruitmentAPIIndex.methodname.updateExpInterview,
            payload: data,
        };
        const response = await client(body);
        return response;
    } catch (error) {}
};

export const getCollegeDetail = async () => {
    let body = {
        modulename: recruitmentAPIIndex.modulename.Onboarding,
        methodname: recruitmentAPIIndex.methodname.getCollegeDetail,
    };
    const response = await client(body);
 
    return response;
};

export const getInterviewers = async (data) => {
    try {
        let body = {
            modulename: recruitmentAPIIndex.modulename.InterviewRound,
            methodname: recruitmentAPIIndex.methodname.getInterviewers,
            payload: data,
        };
        const response = await client(body);
        return response;
    } catch (error) {}
};

export const getOfferLetterTemplate = async () => {
    try {
        let body = {
            modulename: recruitmentAPIIndex.modulename.OfferDetails,
            methodname: recruitmentAPIIndex.methodname.getOfferLetterTemplate,
        };
        const response = await client(body);
        return response;
    } catch (error) {}
};

export const postSalaryDetails = async (data) => {
    try {
        let body = {
            modulename: recruitmentAPIIndex.modulename.OfferDetails,
            methodname: recruitmentAPIIndex.methodname.postSalaryDetails,
            payload: data,
        };
        const response = await client(body);
        return response;
    } catch (error) {}
};

export const updateSalaryDetails = async (data) => {
    try {
        let body = {
            modulename: recruitmentAPIIndex.modulename.OfferDetails,
            methodname: recruitmentAPIIndex.methodname.updateSalaryDetails,
            payload: data,
        };
        const response = await client(body);
        return response;
    } catch (error) {}
};

export const updateExpSalaryDetails = async (data) => {
    try {
        let body = {
            modulename: recruitmentAPIIndex.modulename.OfferDetails,
            methodname: recruitmentAPIIndex.methodname.updateExpSalaryDetails,
            payload: data,
        };
        const response = await client(body);
        return response;
    } catch (error) {}
};

export const postExpSalaryDetails = async (data) => {
    try {
        let body = {
            modulename: recruitmentAPIIndex.modulename.OfferDetails,
            methodname: recruitmentAPIIndex.methodname.postExpSalaryDetails,
            payload: data,
        };
        const response = await client(body);
        return response;
    } catch (error) {}
};

export const sendMail = async (payload) => {
    let body = {
        modulename: recruitmentAPIIndex.modulename.CandidateGrid,
        methodname: recruitmentAPIIndex.methodname.sendMail,
        payload,
    };
    const response = await candidateclient(body);
    return response;
};

// export const directory = async (payload) => {
//   let body = {
//     modulename: recruitmentAPIIndex.modulename.Jobs,
//     methodname: recruitmentAPIIndex.methodname.directory,
//     payload,
//   };

//   const response = await candidateclient(body);
//
//   return response;
// };

export const directory = async (data) => {
    let body = {
        modulename: recruitmentAPIIndex.modulename.performance,

        methodname: recruitmentAPIIndex.methodname.directory,

        payload: data,
    };

    const response = await performanceClient(body);

    return response;
};

export const postExpBulkInterview = async (data) => {
    try {
        let body = {
            modulename: recruitmentAPIIndex.modulename.InterviewRound,
            methodname: recruitmentAPIIndex.methodname.postExpBulkInterview,
            payload: data,
        };
        const response = await client(body);
        return response;
    } catch (error) {}
};

export const postBulkInterview = async (data) => {
    try {
        let body = {
            modulename: recruitmentAPIIndex.modulename.InterviewRound,
            methodname: recruitmentAPIIndex.methodname.postBulkInterview,
            payload: data,
        };
        const response = await client(body);
        return response;
    } catch (error) {}
};

export const postFresherFeedback = async (data) => {
    try {
        let body = {
            modulename: recruitmentAPIIndex.modulename.Feedback,
            methodname: recruitmentAPIIndex.methodname.postFeedback,
            payload: data,
        };
        const response = await client(body);

        return response;
    } catch (error) {}
};

//PC_PA_9 updata preliminary data function
export const updatePrelimAns = async (data) => {
    try {
        //PC_PA_10 create a variable and store the modulename, methodname and payload
        let body = {
            modulename: recruitmentAPIIndex.modulename.Feedback,
            methodname: recruitmentAPIIndex.methodname.updatePrelimAns,
            payload: data,
        };
        const response = await client(body); //PC_PA_11 call the client function
        return response; //PC_PA_17 returns the response
    } catch (error) {}
};

export const postExpFeedback = async (data) => {
    try {
        let body = {
            modulename: recruitmentAPIIndex.modulename.Feedback,
            methodname: recruitmentAPIIndex.methodname.postexpFeedback,
            payload: data,
        };
        const response = await client(body);
        return response;
    } catch (error) {}
};
export const getInterviewRoundName = async (data) => {
    try {
        let body = {
            modulename: recruitmentAPIIndex.modulename.InterviewRound,
            methodname: recruitmentAPIIndex.methodname.getInterviewRoundName,
            payload: data,
        };
        const response = await client(body);
        return response;
    } catch (error) {}
};

export const postStage = async (payload) => {
    let body = {
        modulename: recruitmentAPIIndex.modulename.CandidateGrid,
        methodname: recruitmentAPIIndex.methodname.updateFresherStatus,
        payload,
    };

    const response = await candidateclient(body);

    return response;
};
export const postStages = async (payload) => {
    let body = {
        modulename: recruitmentAPIIndex.modulename.CandidateGrid,
        methodname: recruitmentAPIIndex.methodname.updateExpStatus,
        payload,
    };

    const response = await candidateclient(body);

    return response;
};
export const postOnboarding = async (payload) => {
    let body = {
        modulename: recruitmentAPIIndex.modulename.Offer,
        methodname: recruitmentAPIIndex.methodname.postOnboarding,
        payload,
    };
    const response = await client(body);

    return response;
};
export const postTimeline = async (payload) => {
    let body = {
        modulename: recruitmentAPIIndex.modulename.Timeline,
        methodname: recruitmentAPIIndex.methodname.postTimeline,
        payload,
    };
    const response = await client(body);

    return response;
};
export const removeHiringTeam = async (payload) => {
    let body = {
        modulename: recruitmentAPIIndex.modulename.Jobs,
        methodname: recruitmentAPIIndex.methodname.removeHiringTeam,
        payload,
    };
    const response = await client(body);

    return response;
};

export const getHiringTeamLogin = async (payload) => {
    let body = {
        modulename: recruitmentAPIIndex.modulename.JobsLanding,
        methodname: recruitmentAPIIndex.methodname.getHiringTeamLogin,
        payload,
    };
    const response = await client(body);

    return response;
};
export const updatepublishJobs = async (payload) => {
    let body = {
        modulename: recruitmentAPIIndex.modulename.Jobs,
        methodname: recruitmentAPIIndex.methodname.updatejobs,
        payload,
    };
    const response = await client(body);

    return response;
};

export const postEntity = async (payload) => {
    let body = {
        modulename: recruitmentAPIIndex.modulename.Onboarding,
        methodname: recruitmentAPIIndex.methodname.postEntity,
        payload,
    };
    const response = await client(body);

    return response;
};
export const getEntityId = async (payload) => {
    let body = {
        modulename: recruitmentAPIIndex.modulename.Onboarding,
        methodname: recruitmentAPIIndex.methodname.getEntityId,
        payload,
    };
    const response = await client(body);

    return response;
};
export const postHireStage = async (payload) => {
    let body = {
        modulename: recruitmentAPIIndex.modulename.Onboarding,
        methodname: recruitmentAPIIndex.methodname.postHireStage,
        payload,
    };
    const response = await client(body);

    return response;
};

export const updateSiblings = async (payload) => {
    let body = {
        modulename: recruitmentAPIIndex.modulename.Onboarding,
        methodname: recruitmentAPIIndex.methodname.updateSiblings,
        payload,
    };
    const response = await client(body);

    return response;
};
export const getFresherSearchData = async (payload) => {
    let body = {
        modulename: recruitmentAPIIndex.modulename.CandidateGrid,
        methodname: recruitmentAPIIndex.methodname.getFresherSearchData,
        payload,
    };
    const response = await client(body);

    return response;
};
export const getExpSearchData = async (payload) => {
    let body = {
        modulename: recruitmentAPIIndex.modulename.CandidateGrid,
        methodname: recruitmentAPIIndex.methodname.getExpSearchData,
        payload,
    };
    const response = await client(body);

    return response;
};
export const getCandidateCount = async (payload) => {
    let body = {
        modulename: recruitmentAPIIndex.modulename.Jobs,
        methodname: recruitmentAPIIndex.methodname.getCandidateCount,
        payload,
    };
    const response = await client(body);

    return response;
};
export const getPrelimFeedback = async (payload) => {
    let body = {
        modulename: recruitmentAPIIndex.modulename.Feedback,
        methodname: recruitmentAPIIndex.methodname.getPrelimFeedback,
        payload,
    };
    const response = await client(body);

    return response;
};
export const getJob = async (payload) => {
    let body = {
        modulename: recruitmentAPIIndex.modulename.Jobs,
        methodname: recruitmentAPIIndex.methodname.getSingleJob,
        payload,
    };
    const response = await client(body);

    return response;
};
export const postHireTimeline = async (payload) => {
    let body = {
        modulename: recruitmentAPIIndex.modulename.Timeline,
        methodname: recruitmentAPIIndex.methodname.PostHireTimeline,
        payload,
    };
    const response = await client(body);

    return response;
};
export const RePublishJob = async (payload) => {
    let body = {
        modulename: recruitmentAPIIndex.modulename.Jobs,
        methodname: recruitmentAPIIndex.methodname.republish,
        payload,
    };
    const response = await client(body);

    return response;
};
export const freshercolorfeedback = async (payload) => {
    let body = {
        modulename: recruitmentAPIIndex.modulename.CandidateGrid,
        methodname: recruitmentAPIIndex.methodname.removeHiringTeam,
        payload,
    };
    const response = await client(body);

    return response;
};
export const expColorFeedback = async (payload) => {
    let body = {
        modulename: recruitmentAPIIndex.modulename.CandidateGrid,
        methodname: recruitmentAPIIndex.methodname.updatejobs,
        payload,
    };
    const response = await client(body);

    return response;
};
export const getRejectedReason = async (payload) => {
    let body = {
        modulename: recruitmentAPIIndex.modulename.OfferDetails,
        methodname: recruitmentAPIIndex.methodname.getSearchData,
        payload,
    };
    const response = await client(body);

    return response;
};
export const getFresherCandidateFilterData = async (data) => {
    try {
        let body = {
            modulename: recruitmentAPIIndex.modulename.CandidateGrid,
            methodname: recruitmentAPIIndex.methodname.getFresherFilter,
            payload: data,
        };
        const response = await client(body);
        return response;
    } catch (error) {}
};
export const getExpCandidateFilterData = async (data) => {
    try {
        let body = {
            modulename: recruitmentAPIIndex.modulename.CandidateGrid,
            methodname: recruitmentAPIIndex.methodname.getExpFilter,
            payload: data,
        };
        const response = await client(body);
        return response;
    } catch (error) {}
};
export const getFresherSort = async (data) => {
    try {
        let body = {
            modulename: recruitmentAPIIndex.modulename.CandidateGrid,
            methodname: recruitmentAPIIndex.methodname.republish,
            payload: data,
        };
        const response = await client(body);

        return response;
    } catch (error) {}
};
export const getExpSort = async (data) => {
    try {
        let body = {
            modulename: recruitmentAPIIndex.modulename.CandidateGrid,
            methodname: recruitmentAPIIndex.methodname.getExpSort,
            payload: data,
        };
        const response = await client(body);

        return response;
    } catch (error) {}
};
export const editReviewTask = async (data) => {
    try {
        let body = {
            modulename: recruitmentAPIIndex.modulename.Task,
            methodname: recruitmentAPIIndex.methodname.getOfferLetterTemplate,
            payload: data,
        };
        const response = await client(body);

        return response;
    } catch (error) {}
};
export const getCount = async (data) => {
    try {
        let body = {
            modulename: recruitmentAPIIndex.modulename.CandidateGrid,
            methodname: recruitmentAPIIndex.methodname.getvalue,
            payload: data,
        };
        const response = await client(body);

        return response;
    } catch (error) {}
};
export const updateOfferDetails = async (data) => {
    let body = {
        modulename: recruitmentAPIIndex.modulename.OfferDetails,
        methodname: recruitmentAPIIndex.methodname.getFilterData,
        payload: data,
    };

    const response = await client(body);

    return response;
};
export const updateExpOfferDetails = async (data) => {
    let body = {
        modulename: recruitmentAPIIndex.modulename.OfferDetails,
        methodname: recruitmentAPIIndex.methodname.getSortData,
        payload: data,
    };

    const response = await client(body);

    return response;
};
export const postDocStatus = async (data) => {
    let body = {
        modulename: recruitmentAPIIndex.modulename.Onboarding,
        methodname: recruitmentAPIIndex.methodname.getPreliminary,
        payload: data,
    };

    const response = await client(body);

    return response;
};
export const overallColorFeedback = async (payload) => {
    let body = {
        modulename: recruitmentAPIIndex.modulename.CandidateGrid,
        methodname: recruitmentAPIIndex.methodname.overallcolor,
        payload,
    };
    const response = await client(body);

    return response;
};
export const getTeamsInvite = async (data) => {
    let payload=data;
    payload["access"]=encryptStorage.getItem('token')
    let body = {
        modulename: recruitmentAPIIndex.modulename.JobsLanding,
        methodname: recruitmentAPIIndex.methodname.getFresherDocuments,
        payload,
    };
    const response = await client(body);

    return response;
};
export const getLoginEmailId = async (payload) => {
    let body = {
        modulename: recruitmentAPIIndex.modulename.Timeline,
        methodname: recruitmentAPIIndex.methodname.updateExpTasks,
        payload,
    };
    const response = await client(body);

    return response;
};

export const getFresherEvaluation = async (data) => {
    try {
        let body = {
            modulename: recruitmentAPIIndex.modulename.CandidateGrid,
            methodname: recruitmentAPIIndex.methodname.getFresherRound,
            payload: data,
        };
        const response = await client(body);
        return response;
    } catch (error) {}
};

export const generateBulkOfferLetter = async (data) => {
    let body = {
        modulename: dashboardApiIndex.modulename.dashboard,

        methodname: dashboardApiIndex.methodname.generateBulkOffer,

        payload: data,
    };

    const response = await dashboardClient(body);

    return response;
};

//PC_BI_04 -> getBatchDetails() is defined and batch no is fetched
export const getBatchDetails = async (data) => {
    let body = {
        modulename: recruitmentAPIIndex.modulename.InterviewRound,
        methodname: recruitmentAPIIndex.methodname.getBatchDetails,
        payload: data,
    };

    const response = await client(body);
    //PC_BI_06 -> value is stored in response and it is returned
    return response;
};

//PC_BI_17 -> insertBulkInterviewData() is defined and interview data is inserted
export const insertBulkInterviewData = async (data) => {
    let body = {
        modulename: recruitmentAPIIndex.modulename.InterviewRound,
        methodname: recruitmentAPIIndex.methodname.insertBulkInterviewData,
        payload: data,
    };
    const response = await client(body);
    //PC_BI_19 -> value is stored in response and it is returned
    return response;
};

//PC_EM_06 -> sendEmailCandidate() is defined and Email send based on the status of candidate for the job
export const sendMailCandidate = async (data) => {
    let body = {
        modulename: recruitmentAPIIndex.modulename.InterviewRound,
        methodname: recruitmentAPIIndex.methodname.sendMailCandidate,
        payload: data,
    };
    const response = await client(body);
    //value is stored in response and it is returned
    return response;
};

//PC_FB_21 -> updateFeedBackData() is defined and update call is made
export const updateFeedBackData = async (data) => {
    let body = {
        modulename: recruitmentAPIIndex.modulename.InterviewRound,
        methodname: recruitmentAPIIndex.methodname.updateFeedBackData,
        payload: data,
    };
    const response = await client(body);
    //PC_FB_23 -> value is stored in response and it is returned
    return response;
};
